/**
 * Generates a random UUID (v4) with fallback for non-secure contexts
 * where crypto.randomUUID is not available.
 */
export function generateUUID(): string {
  // Check if crypto and randomUUID exist and is actually a function
  if (typeof crypto !== 'undefined' && crypto.randomUUID && typeof crypto.randomUUID === 'function') {
    try {
      return crypto.randomUUID();
    } catch (e) {
      // If crypto.randomUUID fails, fall through to fallback
      console.warn('crypto.randomUUID() failed, using fallback:', e);
    }
  }

  // Fallback for non-secure contexts or older browsers
  // This is a simple version of RFC4122 version 4 compliant UUID generator
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}
